import { createContext } from "react";

export const OrganizationsContext = createContext(null);
